  <div>
    <div [hidden]="!viewToggled" class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      @if (!isCreatingEntity) {
        <div class="field-label fx-flex-100-33-percent">
          {{ fieldConfig.label }}
          @if (fieldConfig.tooltip) {
            <span #tooltip="matTooltip" (click)="onClickTooltip(tooltip)"
                  [matTooltip]="fieldConfig.tooltip">
              <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon"></mat-icon>
            </span>
          }
        </div>
      }
      @if (preconditionsForEdition) {
        <div class="field-container fx-flex-100-66-percent fx-layout-col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'LABEL.ASSET_TYPE_NAME' | translate }}</mat-label>
            <mat-select-asset-type-autocomplete #inputField [disabled]="(asyncPreconditionsForEdition$ | async) === false"
                                                [required]="fieldConfig.customOptions?.required"
                                                [entityType]="entity?.objectType"
                                                [formControl]="form.controls.field">
            </mat-select-asset-type-autocomplete>
            @if (isCreatingEntity && fieldConfig.tooltip) {
              <span matTextSuffix matTooltipPosition="below"
                    [matTooltip]="fieldConfig.tooltip" #tooltip="matTooltip" (click)="onClickTooltip(tooltip)">
                <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon"></mat-icon>
              </span>
            }
          </mat-form-field>
          @if (isSingleField) {
            <div class="save-options">
              <button (click)="onClickCancel()" (keyup.escape)="onEscapeCancel($event)" class="button">
                <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
              </button>
              <button (click)="onClickSave()" (keyup.escape)="onEscapeCancel($event)" [disabled]="!form.valid"
                      class="button save">
                <mat-icon fontSet="mdi" fontIcon="mdi-check"></mat-icon>
              </button>
            </div>
          }
        </div>
      } @else {
        <div class="field-container clickable-field fx-flex-100-66-percent fx-layout-col">
          <div
            [ngClass]="{'read-value': accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition}"
            tabindex="0">
            @if (accessManager.hasAllNeededPermissions(permissionsForEdition)) {
              <span class="overlay-icon">
                <mat-icon fontSet="mdi" fontIcon="mdi-pencil-off" class="tooltip-icon"></mat-icon>
              </span>
            }
          </div>
        </div>
      }
    </div>
  </div>

